import { render, staticRenderFns } from "./home.vue?vue&type=template&id=56e72ea4&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=56e72ea4&prod&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=56e72ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e72ea4",
  null
  
)

export default component.exports